import {
    OrderReturnStatus,
    OrderReturnStatusTypes,
} from "./order-return-response";

function resolveStatusColor(type) {
    switch (type) {
        case OrderReturnStatusTypes.OPEN:
            return "grey";
        case OrderReturnStatusTypes.CANCELED:
            return "red";
        case OrderReturnStatusTypes.IN_PROCESS:
            return "dark-blue";
        case OrderReturnStatusTypes.PARTIALLY_COMPLETED:
            return "orange";
        case OrderReturnStatusTypes.COMPLETED:
            return "green";
        default:
            return "grey";
    }
}

const getStatusText = ({ type, text }: OrderReturnStatus): string => {
    const statusColor = resolveStatusColor(type);
    return `<span class="ux-text-status ux-text-status--${statusColor}">${text}</span>`;
};

export default getStatusText;
